import { createSlice } from "@reduxjs/toolkit";
import { getAllShuffleTickets, getMyTickets } from "./ticketServices";

const initialState = {
  allShuffleTickets: {
    isTicketsLoading: null,
    isTicketsSuccess: null,
    shuffleMessage: null,
    shuffledTickets: [],
  },
  myTickets: {
    isLoading: null,
    isSuccess: null,
    message: null,
    data: [],
    pageCount: null,
  },
};

const ticketSlice = createSlice({
  name: "ticket",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllShuffleTickets.pending, (state) => {
        state.allShuffleTickets = {
          ...initialState.allShuffleTickets,
          isTicketsLoading: true,
          shuffleMessage: "Loading tickets...",
        };
      })
      .addCase(getAllShuffleTickets.rejected, (state, action) => {
        state.allShuffleTickets = {
          ...initialState.allShuffleTickets,
          isTicketsLoading: false,
          isTicketsSuccess: false,
          shuffleMessage: action.payload,
        };
      })
      .addCase(getAllShuffleTickets.fulfilled, (state, action) => {
        state.allShuffleTickets = {
          ...initialState.allShuffleTickets,
          isTicketsLoading: false,
          isTicketsSuccess: true,
          shuffleMessage: action.payload.message,
          shuffledTickets: action.payload,
        };
      })

      .addCase(getMyTickets.pending, (state) => {
        state.myTickets = {
          ...initialState.myTickets,
          isLoading: true,
          message: "Loading...",
        };
      })
      .addCase(getMyTickets.rejected, (state, action) => {
        state.myTickets = {
          ...initialState.myTickets,
          isLoading: false,
          isSuccess: false,
          message: action.payload,
        };
      })
      .addCase(getMyTickets.fulfilled, (state, action) => {
        state.myTickets = {
          ...initialState.myTickets,
          isLoading: false,
          isSuccess: true,
          data: action.payload?.data || [],
          message: action.payload?.message,
          pageCount: action.payload?.pageCount || 0,
        };
      });
  },
});

export default ticketSlice.reducer;
